var UserFlags = {
  PUSHLY_ENG: {
    key: 'PUSHLY_ENG',
    name: 'Pushly Engineering Team',
    active: true
  }
};
var OrgFlags = {
  DEMO: {
    key: 'DEMO',
    name: 'Demo Org',
    active: true
  },
  INTERNAL: {
    key: 'INTERNAL',
    name: 'Internal',
    active: true
  },
  PUB_NETWORK: {
    key: 'PUB_NETWORK',
    name: 'Pub Network',
    active: true
  },
  FEAT_MULTI_DOMAIN_NOTIFICATIONS: {
    key: 'FEAT_MULTI_DOMAIN_NOTIFICATIONS',
    name: 'Multi-Domain Notifications',
    active: true
  },
  FEAT_NOTIF_INF_DELIVERY: {
    key: 'FEAT_NOTIF_INF_DELIVERY',
    name: 'Notification Informed Delivery',
    active: true
  },
  // Deprecated
  V2_VENTURES: {
    key: 'V2_VENTURES',
    name: 'V2',
    active: false
  },
  AMPLY: {
    key: 'AMPLY',
    name: 'Amply',
    active: false
  }
};
var DomainFlags = {
  DEMO: {
    key: 'DEMO',
    name: 'Demo Domain',
    active: true
  },
  FEAT_ABANDONED_VIEW_CAMPAIGNS: {
    key: 'FEAT_ABANDONED_VIEW_CAMPAIGNS',
    name: 'Abandoned View Campaigns',
    active: true
  },
  FEAT_ALLOW_TIMEZONE_DELIVERY: {
    key: 'FEAT_ALLOW_TIMEZONE_DELIVERY',
    name: 'Allow Time Zone Delivery',
    active: false
  },
  FEAT_AMPLY_DEFAULT_AD_COLLAPSE_KEY: {
    key: 'FEAT_AMPLY_DEFAULT_AD_COLLAPSE_KEY',
    name: 'Amply: Use Default Ad Collapse Key',
    active: true
  },
  FEAT_AUTO_KW_DISCOVERY: {
    key: 'FEAT_AUTO_KW_DISCOVERY',
    name: 'Auto Keyword Discovery',
    active: true
  },
  FEAT_CALCULATE_PAGE_AUDIENCE_VISITS: {
    key: 'FEAT_CALCULATE_PAGE_AUDIENCE_VISITS',
    name: 'Calculate Page Audience Visits',
    active: true
  },
  FEAT_CAMPAIGN_WEBHOOK_ACTIONS: {
    key: 'FEAT_CAMPAIGN_WEBHOOK_ACTIONS',
    name: 'Campaign Webhook Actions',
    active: true
  },
  FEAT_CUSTOM_VAPID: {
    key: 'FEAT_CUSTOM_VAPID',
    name: 'Custom Vapid',
    active: true
  },
  FEAT_INLINE_SEG: {
    key: 'FEAT_INLINE_SEG',
    name: 'Inline Segmentation',
    active: true
  },
  FEAT_DOMAIN_FALLBACK_NOTIFICATION: {
    key: 'FEAT_DOMAIN_FALLBACK_NOTIFICATION',
    name: 'Fallback Notification',
    active: true
  },
  FEAT_DOMAIN_INTEGRATIONS: {
    key: 'FEAT_DOMAIN_INTEGRATIONS',
    name: 'Integrations',
    active: true
  },
  FEAT_DOMAIN_INTEGRATIONS_ECOMM: {
    key: 'FEAT_DOMAIN_INTEGRATIONS_ECOMM',
    name: 'E-Comm Integrations',
    active: true
  },
  FEAT_DOMAIN_INTEGRATIONS_SLACK: {
    key: 'FEAT_DOMAIN_INTEGRATIONS_SLACK',
    name: 'Slack Integrations',
    active: true
  },
  FEAT_DOMAIN_INTEGRATIONS_PUB_NETWORK: {
    key: 'FEAT_DOMAIN_INTEGRATIONS_PUB_NETWORK',
    name: 'Pub Network Integrations',
    active: true
  },
  FEAT_NOTIF_ACTIONS: {
    key: 'FEAT_NOTIF_ACTIONS',
    name: 'Notification Actions',
    active: true
  },
  FEAT_NOTIF_DUPLICATE_CHECKS: {
    key: 'FEAT_NOTIF_DUPLICATE_CHECKS',
    name: 'Notification Duplicate Checks',
    active: true
  },
  FEAT_NOTIF_FIELD_SUGGESTIONS: {
    key: 'FEAT_NOTIF_FIELD_SUGGESTIONS',
    name: 'Notification Field Suggestions',
    active: true
  },
  FEAT_NOTIF_INF_DELIVERY: {
    key: 'FEAT_NOTIF_INF_DELIVERY',
    name: 'Notification Informed Delivery',
    active: true
  },
  FEAT_NOTIF_REQUIRE_INTERACTION_TOGGLE: {
    key: 'FEAT_NOTIF_REQUIRE_INTERACTION_TOGGLE',
    name: 'Require Interaction Toggle',
    active: true
  },
  FEAT_IMM_NOTIF_CONFIRM: {
    key: 'FEAT_IMM_NOTIF_CONFIRM',
    name: 'Confirm Immediate Delivery',
    active: true
  },
  FEAT_NOTIF_SOURCE_FILTERING: {
    key: 'FEAT_NOTIF_SOURCE_FILTERING',
    name: 'Notification Source Filter',
    active: true
  },
  FEAT_PREFERENCES: {
    key: 'FEAT_PREFERENCES',
    name: 'Subscriber Preferences',
    active: true
  },
  FEAT_VAPID_ONLY: {
    key: 'FEAT_VAPID_ONLY',
    name: 'Vapid Only',
    active: true
  },
  FEAT_SCHED_NOTIF_CONFIRM: {
    key: 'FEAT_SCHED_NOTIF_CONFIRM',
    name: 'Confirm Scheduled Delivery',
    active: true
  },
  FEAT_SDK_RESTRICT_MULTI_SUBS: {
    key: 'FEAT_SDK_RESTRICT_MULTI_SUBS',
    name: 'SDK: Restrict Multi-Subs',
    active: true
  },
  FEAT_SHOW_CUSTOM_LOCATION_INPUT: {
    key: 'FEAT_SHOW_CUSTOM_LOCATION_INPUT',
    name: 'Show Custom Location Input',
    active: true
  },
  FEAT_SHOW_TIME_VARIANT: {
    key: 'FEAT_SHOW_TIME_VARIANT',
    name: 'Show Time Variant',
    active: true
  },
  FEAT_USE_DATA_BROKER: {
    key: 'FEAT_USE_DATA_BROKER',
    name: 'Use Brokered SDK',
    active: true
  },
  FEAT_RESTRICT_ALL_SUB_NOTIFS: {
    key: 'FEAT_RESTRICT_ALL_SUB_NOTIFS',
    name: 'Restrict All-Subs Delivery',
    active: true
  },
  PREVIEW_DOMAIN: {
    key: 'PREVIEW_DOMAIN',
    name: 'Is Preview Domain',
    active: true
  },
  USE_BLOWHOLE_RESPONSE_CACHE: {
    key: 'USE_BLOWHOLE_RESPONSE_CACHE',
    active: true
  },
  USE_ISOLATED_COOKIE_STORAGE_LOCATION: {
    key: 'USE_ISOLATED_COOKIE_STORAGE_LOCATION',
    name: 'SDK: Isolated Cookies',
    active: true
  },
  USE_ROOT_SW_SCOPE: {
    key: 'USE_ROOT_SW_SCOPE',
    name: 'SW: Root Scope',
    active: true
  },
  USE_S3_JOB_CACHE: {
    key: 'USE_S3_JOB_CACHE',
    active: true
  },
  WEBPUSH_UNSUBSCRIBE: {
    key: 'WEBPUSH_UNSUBSCRIBE',
    active: true
  },
  // Deprecated
  AMPLY: {
    key: 'AMPLY',
    name: 'Amply',
    active: false
  },
  FEAT_CAMPAIGNS: {
    key: 'FEAT_CAMPAIGNS',
    name: 'Campaigns',
    active: false
  },
  FEAT_NOTIF_PREVIEWS: {
    key: 'FEAT_NOTIF_PREVIEWS',
    name: 'Notification Previews',
    active: false
  },
  FEAT_SNS_EVENT_STREAM: {
    key: 'FEAT_SNS_EVENT_STREAM',
    name: 'SNS Event Streams',
    active: false
  }
};
export var Flags = {
  user: UserFlags,
  org: OrgFlags,
  domain: DomainFlags
};
export function getActiveFlags(source) {
  var sourceKeys = Object.keys(Flags[source]);
  return sourceKeys.filter(function (flag) {
    return Flags[source][flag].active;
  }).map(function (flag) {
    return Flags[source][flag];
  });
}
export function isFlagActive(source, flag) {
  return getActiveFlags(source).map(function (f) {
    return f.key;
  }).includes(flag);
}
export function isFlagKnown(source, flag) {
  return Object.keys(Flags[source]).includes(flag);
}